import { render } from "./UpdateProjectDetailsForm.vue?vue&type=template&id=f96e1d4c&scoped=true"
import script from "./UpdateProjectDetailsForm.vue?vue&type=script&lang=js"
export * from "./UpdateProjectDetailsForm.vue?vue&type=script&lang=js"

import "./UpdateProjectDetailsForm.vue?vue&type=style&index=0&id=f96e1d4c&scoped=true&lang=css"

import exportComponent from "C:\\xampp\\htdocs\\ms\\ms-by-bimms\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f96e1d4c"]])

export default __exports__